import { MutableRefObject, useEffect, useRef } from "react";

/**
 * Hook that sets the initial focus to the element when the component is mounted.
 * @param options for the hook allows the conditional focusing of the element.
 * @returns Ref object of the element to set focus.
 */

interface Options {
  shouldFocus?: boolean;
}

export const useInitialFocus = <T extends HTMLElement>(
  options?: Options
): MutableRefObject<T | null> => {
  const elementRef = useRef<T | null>(null);

  useEffect(() => {
    if (options?.shouldFocus === undefined || options?.shouldFocus) {
      elementRef.current?.focus();
    }
  }, [elementRef, options?.shouldFocus]);

  return elementRef;
};
